import React from 'react';

const CompareModesView = ({ rows = [], onPlayerClick, playerImages = {} }) => {
  return (
    <div className="map-performance-container">
      <div className="table-wrapper compare-modes-card">
        <table className="performance-table compare-modes-table">
          <thead>
            <tr>
              <th>Player</th>
              <th>HP K/D</th>
              <th>S&amp;D K/D</th>
              <th>CTRL K/D</th>
              <th>Avg Damage</th>
              <th>Avg Score</th>
              <th>Win %</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={8} className="compare-empty-cell">No compare data found for current filters.</td>
              </tr>
            )}
            {rows.map((row) => (
              <tr key={row.Player}>
                <td>
                  <div className="player-name-cell">
                    {playerImages[row.Player] && (
                      <img
                        src={playerImages[row.Player]}
                        alt={row.Player}
                        className="compare-player-avatar"
                      />
                    )}
                    <button className="player-name-link" onClick={() => onPlayerClick(row.Player)}>
                      {row.Player}
                    </button>
                  </div>
                </td>
                <td>{row.hpKd}</td>
                <td>{row.sndKd}</td>
                <td>{row.ctlKd}</td>
                <td>{row.avgDamage}</td>
                <td>{row.avgScore}</td>
                <td>{row.winPct || '0%'}</td>
                <td>
                  <button className="action-btn" onClick={() => onPlayerClick(row.Player)}>
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CompareModesView;
